import React, {useEffect, useState} from "react";
import {getOnline_api} from "./OrdersServices";
import {OnlineCard} from "./OnlineCard";
import "./Orders.scss"

function OnlineTab() {

    const [data,set_data] = useState([]);

    useEffect(()=>{
        getOnline_func()
    },[])

    const getOnline_func = async ()=>{
        try{
            const response = await getOnline_api(1);
            console.log("Response  : ",response)
            set_data(response.data.results)
        }catch (e) {
            console.log(e)
        }
    }


    const HandleScrollListener = async () =>{
        const doc = document.documentElement;
        let calc = doc.scrollHeight -(doc.scrollTop + doc.clientHeight)
        let cond = calc>3 || calc<-3
        if(!cond) {
            console.log("bottonnnnn");
            pageinate()
        }
    }

    useEffect(()=>{
        //handle scroll arrived to Top
        window.OrderCuPage = 1;
        window.addEventListener('scroll',HandleScrollListener);
        return () => {
            window.removeEventListener('scroll', HandleScrollListener); // Remove Scroll Event Listener
        };
    },[])

    const pageinate = async ()=>{
        window.OrderCuPage = window.OrderCuPage+1;
        try{
            const response = await getOnline_api(window.OrderCuPage);
            set_data((list)=>[...list,...response.data.results]);
        }catch (e) {
            console.log(e)
        }
    }


    return(
        <div className="onlineTab-container">
            {data.map(item=>{
                return(
                    <OnlineCard item={item}/>
                )
            })}
            </div>
    )
}

export {OnlineTab}
